import { filterBy } from "@progress/kendo-data-query";
import { Button } from "@progress/kendo-react-buttons";
import { ComboBox, ComboBoxChangeEvent, ComboBoxFilterChangeEvent, DropDownList } from "@progress/kendo-react-dropdowns";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getParamsSelector, updateParams } from "../Common/Slices/ParamSlice";
import { useAppDispatch } from "../Core/store.hooks";
import FormatAlarms from "./FormatAlarms";
import { getAlarmsLoadingSelector, getAlarmsSelector } from "./Slice";

interface AlarmFilterProps{
    id:string;
}

const AlarmFilters = (props:AlarmFilterProps) =>{
    const [alarmTexts, updateAlarmTexts] = useState([])
    const [alarmText, updateAlarmText] = useState<any>()
    const [loadingState, updateLoadingState] = useState(Boolean); const [alarmsListLoading, updateAlarmsListLoading] = useState<boolean>(false);

    const params = useSelector(getParamsSelector)
    const alarms = useSelector(getAlarmsSelector)
    const alarmsLoading = useSelector(getAlarmsLoadingSelector)
    const dispatch = useAppDispatch();
    
    useEffect(()=>{
        if(alarms !== null && alarms!=undefined){
            if (alarms.length > 0 ){
                updateAlarmTexts(FormatAlarms.alarmTexts(alarms))
            }
        }
    },[alarms])

    useEffect(()=>{
        updateAlarmText(params.alarmText)
    },[params.alarmText])

    useEffect(()=>{
        if (alarmsLoading === 'pending'){
            updateLoadingState(true)
        }else{
            updateLoadingState(false)
        }
    },[alarmsLoading])
    
    const handleChange = (e:ComboBoxChangeEvent) =>{
        
        updateAlarmText(e.target.value)
    }

    const paramsHandler = () => {
        let newParams = {...params}
        newParams.alarmText = alarmText
        dispatch(updateParams(newParams))
    }

    const alarmTextFilters = (event: ComboBoxFilterChangeEvent) => {
        updateAlarmTexts(
            filterBy(
                FormatAlarms.alarmTexts(alarms),
                event.filter
            )
        );
    }

    return ( 
        <Fragment>
            <div>Alarm Text</div>
            <ComboBox
                style={{fontSize:"small",width:"95%"}}
                popupSettings={{ width: "80vw",}}
                data={alarmTexts}
                value={alarmText}
                onChange={handleChange}
                placeholder="choose alarm"
                suggest={true}
                filterable={true}
                onFilterChange={alarmTextFilters}
                loading={loadingState}
            />
            <div className="k-textbox-container metricCombo">
                <Button onClick={() => paramsHandler()}>
                    UPDATE
                </Button>
            </div>
        </Fragment>
    )
}

export default AlarmFilters;